import { useTheme } from '@mui/material';

import { COLORS } from '@constants/colors';
import { DEVICES_LANDSCAPE_SIZES } from '@constants/devicesSizes';

import { IChatDrawerViewStyles } from './interfaces';
import { useMytaverseEvent } from '@core/dashboard/providers';

import { useChatState } from '@core/chat';
import { ScreenSizes } from '@interfaces';

export const useStyles = ({
  isLoading,
  hasScreenMediaStreams,
  isExpanded,
}: IChatDrawerViewStyles) => {
  const { breakpoints } = useTheme();
  const { isMinimizedScreenSharing } = useMytaverseEvent();

  const { chatDrawerWidth } = useChatState();

  return {
    root: {
      '& .MuiPaper-root': {
        top: hasScreenMediaStreams && !isMinimizedScreenSharing ? '225px' : 0,
        display: 'grid',
        gridTemplateRows: isLoading ? 'auto 1fr' : 'auto auto 1fr',
        backgroundColor: COLORS.BACKGROUND_COLOR,
        backdropFilter: 'blur(12px)',
        width: chatDrawerWidth,
        height:
          hasScreenMediaStreams && !isMinimizedScreenSharing
            ? 'calc(100vh - 225px)'
            : '100%',
        /*[breakpoints.down(DEVICES_LANDSCAPE_SIZES.MOBILE)]: {
          width: isExpanded ? '90%' : '50%',
          zIndex: 1500,
          overflow: 'unset',
        },*/
      },
      position: 'static',
      '& a': {
        color: COLORS.WHITE,
      },
    },
    collapse: {
      color: COLORS.WHITE,
      backgroundColor: COLORS.BACKGROUND_COLOR,
      backdropFilter: 'blur(6px)',
      borderRadius: '10px',
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      py: 2.5,
      px: 0,
      paddingLeft: 0.5,
      width: 'auto',
      height: 'auto',
      visibility: 'hidden',
      /*[breakpoints.down(DEVICES_LANDSCAPE_SIZES.MOBILE)]: {
        visibility: 'visible',
      },*/
    },
    collapseWrap: {
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translate(-50%, -50%)',
      zIndex: 12,
      '& svg': {
        color: 'inherit',
        height: '14px',
        width: '14px',
        opacity: 1,
      },
    },
    modalContainer: {
      gap: '16px',
      padding: '25px 20px 10px 20px',
    },
    tabs: {
      margin: '0 !important',
      padding: '0 !important',
    },
    box: {
      height: 556,
      maxHeight: 'calc(100dvh - 306px)',

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: 'calc(100vh - 203px)',
        maxHeight: 'calc(100dvh - 203px)',
      },
    },
  };
};
